<div mat-dialog-title id="selectAttributesTitle">{{ 'SelectAttributesTitle' | translate:locale.language }}</div>
<div mat-dialog-content>
  <div class="collection">
    @for (attribute of attributes; track attribute) {
      <a href="javascript:;" class="collection-item as-blue-highlight"
        id="attributeItem"
        (click)="onSelect(attribute)"
      [class.active]="isSelected(attribute)">{{ attribute.name }}</a>
    }
  </div>
</div>